/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsFinanceDetails204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsFinanceDetails505Schema = z.any();

export const optionsFinanceDetailsMutationResponseSchema = z.lazy(() => optionsFinanceDetails204Schema);
